import axios from 'axios';
import { API_URL } from './api';


const _err = (error) => {
    if (error.response) {
        console.error('Partner Auth API error:', error.response.status, error.response.data);
    } else {
        console.error('Partner Auth API error:', error.message);
    }
};


// POST /partner/auth/login/   {email, password}
export const APIPartnerLogin = async ({ email, password }) => {
    try {
        const response = await axios.post(
            `${API_URL}/partner/auth/login/`,
            { email, password },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /partner/auth/logout/
export const APIPartnerLogout = async (token) => {
    try {
        const response = await axios.post(
            `${API_URL}/partner/auth/logout/`,
            {},
            { headers: { 'Authorization': `Bearer ${token}` } }
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /partner/auth/request-password-reset/   {email}
export const APIPartnerRequestPasswordReset = async (email) => {
    try {
        const response = await axios.post(
            `${API_URL}/partner/auth/request-password-reset/`,
            { email },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /partner/auth/reset-password/   {token, new_password}
export const APIPartnerResetPassword = async ({ token, new_password }) => {
    try {
        const response = await axios.post(
            `${API_URL}/partner/auth/reset-password/`,
            { token, new_password },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /partner/auth/change-password/   (auth required) {old_password, new_password}
export const APIPartnerChangePassword = async (token, { old_password, new_password }) => {
    try {
        const response = await axios.post(
            `${API_URL}/partner/auth/change-password/`,
            { old_password, new_password },
            { headers: { 'Authorization': `Bearer ${token}` } }
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};